module.exports = __webpack_public_path__ + "img/daily.80facb82.jpeg";